<template>
  <NuxtLink
    class="customer-service-faq-item flex rounded-l border-none overflow-hidden w-full md:rounded"
    :to="{ path: $i18n.localePath(to) }"
  >
    <span class="rounded-border bg-blue-400 rounded-l" />
    <span class="customer-service-faq-item-content block py-6 px-3 bg-new-grey h-full flex-1 md:pt-0 relative">
      <span class="h-full md:flex md:justify-center md:items-center">
        <span class="flex items-center h-full md:flex-col md:text-center md:justify-center">
          <span>
            <OSvg class="icon" :svg="icon" />
          </span>
          <span class="pl-4 flex-1 md:flex-none md:pl-0">
            <p class="mb-1 font-semibold ota-p16 md:mt-5 md:mb-1" v-text="title" />
            <p class="ota-p14" v-text="description" />
          </span>
        </span>
      </span>
      <span class="md-rounded-border hidden bg-blue-400 rounded-t" />
    </span>
  </NuxtLink>
</template>

<script>
import OSvg from '@/components/OSvg/OSvg'

export default {
  name: 'CustomerServiceFaqItem',
  components: {
    OSvg
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    to: {
      type: Object,
      default: () => ({}),
      validator: value => ['name'].every(prop => value.hasOwnProperty(prop))
    }
  }
}
</script>

<style lang="postcss" scoped>
.bg-blue-400 {
  background-color: #6362EC;
}

.bg-new-grey {
  background-color: #F7F7F7;
}

.rounded-border {
  width: 1rem;
}

.customer-service-faq-item {
  &-content {
    svg.icon {
      width: 3.4rem;

      >>> path {
        @apply fill-black;
        stroke: #000 !important;

        &[fill="transparent"] {
          fill: transparent !important;
        }
      }
    }
  }
}

@screen md {
  .customer-service-faq-item {
    @apply block relative;
    content: "";
    padding-bottom: 100%;

    &-content {
      @apply absolute w-full h-full;
    }
  }

  .md-rounded-border {
    @apply block absolute top-0 left-0 right-0 w-full h-rem;
  }
}
</style>
